<template>
    <div id="signupSection">
        <card>
            <Row id="operation">
                <Button type="primary" @click="add" size="small">新增</Button>
            </Row>
            <Table :columns="columns" :data="data" :loading="dataLoading"></Table>
            <Page :total="pageTotalNum" :current="pageCurrent" v-if="showPager" show-elevator show-total
                  @on-change="changePage"></Page>
        </card>
        <signupForm ref="signupForm" v-on:close="onCloseForm"></signupForm>
        <recordForm ref="recordForm" ></recordForm>
    </div>
</template>
<script>
    import signupForm from './form.vue';
    import recordForm from './record.vue';

    export default {
        name: 'singup',
        data () {
            return {
                columns: [
                    {
                        title: '标题',
                        key: 'title',
                        width:220
                    },
                    {
                        title: '校区',
                        key: 'zonename',
                        width:120
                    },
                    {
                        title: '状态',
                        key: 'state',
                        width:120,
                        render: (h, params) => {
                            if (params.row.state == 1){
                                return h('Tag',
                                    {
                                        props: {
                                            color: 'primary'
                                        },
                                    },'正常');
                            }else{
                                return h('Tag',
                                    {
                                        props: {
                                            color: 'error'
                                        },
                                    },'禁用');
                            }

                        }
                    },
                    {
                        title:'访问地址',
                        width:400,
                        render: (h, params) => {
                            return h('div','http://mpv2.xmxiaomai.com/wx/1/#/signup_index?id='+params.row.id);
                        }
                    },
                    {
                        title: '操作',
                        render: (h, params) => {
                            let self = this;

                            let opArray = [];

                            opArray.push(h('Button', {
                                props: {
                                    type: 'info',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.$refs.recordForm.showWin(params.row.id);
                                    }
                                }
                            }, '报名清单'));

                            opArray.push(h('Button', {
                                props: {
                                    type: 'info',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.$refs.signupForm.showWin(params.row.id);
                                    }
                                }
                            }, '修改'));

                            opArray.push(h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        self.$Modal.confirm({
                                            title: '提示',
                                            content: '是否确定删除？',
                                            onOk: () => {
                                                self.$api.signup.del({id:params.row.id}).then(resp => {
                                                    if (resp.state == 'ok'){
                                                        self.$Message.info('删除成功');
                                                        self.getList();
                                                    }else{
                                                        self.$Message.error(resp.msg);
                                                    }
                                                });
                                            },
                                            onCancel: () => {

                                            }
                                        });
                                    }
                                }
                            }, '删除'));
                            return h('div',opArray);
                        }
                    }
                ],
                data: [],
                dataLoading: false,
                ruleInline: {

                },
                totalPage:0,
                pageTotalNum:0,
                pageCurrent:1
            }
        },
        computed: {
            showPager : function(){
                return this.totalPage > 1
            }
        },
        methods: {
            getList(){
                this.dataLoading = true;
                let param = {
                    p:this.pageCurrent
                }
                this.$api.signup.getList(param).then(resp => {
                    this.data = resp.data.list;
                    this.pageTotalNum = resp.data.totalRow;
                    this.totalPage = resp.data.totalPage;
                    this.pageCurrent = resp.data.pageNumber;
                    this.dataLoading = false;
                });
            },
            add(){
                this.$refs.signupForm.showWin();
            },
            changePage (page) {
                this.pageCurrent = page;
                this.getList();
            },
            doSearch(){
                this.pageCurrent = 1;
                this.getList();
            },
            onCloseForm(){
                this.getList();
            }
        },
        mounted: function () {
            this.getList();
        },
        components: {
            signupForm,
            recordForm
        }
    }
</script>
